export default "__VITE_ASSET__DL433hHp__"